/**
 * Chaves padronizadas pros tutoriais contextuais.
 * MAIN é o tour inicial do Dashboard — usa o campo legado `tutorial_completed_at`.
 * Os secundários usam `tutorials_seen[key]`.
 */
export const TUTORIAL_KEYS = {
  MAIN: 'main',
  TRAILS: 'trails',
  RANKING: 'ranking',
} as const;

export type TutorialKey = (typeof TUTORIAL_KEYS)[keyof typeof TUTORIAL_KEYS];
